import { useEffect, useState } from 'react';
import { FileTypeProps } from '.';

type UseViewModelProps = {
  approvedLists: FileTypeProps[];
  failedLists: FileTypeProps[];
};

type UseViewModelReturn = {
  value: string;
  fileLists: FileTypeProps[];
  handleChangeTabs: (newValue: string) => void;
};

const useViewModel = ({
  approvedLists,
  failedLists,
}: UseViewModelProps): UseViewModelReturn => {
  const [value, setValue] = useState('approved');
  const [fileLists, setFileLists] = useState([]);

  // update file for changing tab's value
  useEffect(() => {
    if (value === 'approved' && approvedLists?.length > 0) {
      setFileLists(approvedLists);
    } else {
      setFileLists(failedLists);
    }
  }, [value, approvedLists, failedLists]);

  const handleChangeTabs = (newValue: string): void => {
    setValue(newValue);
  };

  return {
    value,
    fileLists,
    handleChangeTabs,
  };
};
export default useViewModel;
